import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AI_API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const SuggestMachines = createAsyncThunk(
  "SuggestMachines",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: AI_API_URL.BASEURL + AI_API_URL.SUGGEST_MACHINES,
          body: data,
        },
        false
      );
      return resData;
    } catch (error) {}
  }
);

export const GetMachines = createAsyncThunk(
  "GetMachines",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: AI_API_URL.BASEURL + AI_API_URL.GET_MACHINES,
          body: data,
        },
        false
      );
      return resData;
    } catch (error) {}
  }
);
export const VectorStore = createAsyncThunk(
  "VectorStore",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: AI_API_URL.BASEURL + AI_API_URL.VECTOR_STORE,
          body: data,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

const initialState = {
  SuggestMachinesData: {
    data: null,
    error: null,
  },
  GetMachinesData: {
    data: null,
    error: null,
  },
  VectorStoreData: {
    data: null,
    error: null,
  },
};

const AIAPISlice = createSlice({
  name: "AIAPI",
  initialState,
  reducers: {
    // setLoader: (state, action) => {
    //   state.isLoading = action.payload;
    // },
    //   setWorkFlowGetListData: (state) => {
    //     state.WorkFlowGetListData.data = null;
    //   },
    // setBlogGetListNewsData: (state) => {
    //   state.BlogGetListNewsData.data = null;
    // },
  },

  extraReducers: (builder) => {
    builder
      .addCase(SuggestMachines.fulfilled, (state, action) => {
        state.SuggestMachinesData.data = action.payload;
      })
      .addCase(SuggestMachines.rejected, (state, action) => {
        state.SuggestMachinesData.error = action.error.message;
      })
      .addCase(GetMachines.fulfilled, (state, action) => {
        state.GetMachinesData.data = action.payload;
      })
      .addCase(GetMachines.rejected, (state, action) => {
        state.GetMachinesData.error = action.error.message;
      })
      .addCase(VectorStore.fulfilled, (state, action) => {
        state.VectorStoreData.data = action.payload;
      })
      .addCase(VectorStore.rejected, (state, action) => {
        state.VectorStoreData.error = action.error.message;
      });
  },
});

// export const { setBlogGetListNewsData } = AIAPI.actions;
export default AIAPISlice.reducer;
